export const histologyModule = {
  id: "histology",
  title: "Blood Circulation",
  sections: [
    {
      type: "text",
      content: `<h3>Lung Anatomy
        ,`,

      image: "/images/lungs/LungAnatomy.jpg",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "text",
      content: "",
      image: "/images/heart/blood-flow.jpg",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
  ],
};
